import React, { useEffect, useState } from 'react'
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { Button, Form, Modal } from 'react-bootstrap';
import { RiStethoscopeFill } from 'react-icons/ri';
import { MdAdd, MdDelete } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { allBranchDetail, allCounselorDetail, allDoctorSearchDetail, searchAllCounselorDetail } from '../../../redux/actions/Files.action';
import { addTreatment, deleteTreatment, getTreatment, updateTreatment } from '../../../redux/actions/Doctor.action';
import { getTherapist, searchCounselor, searchTherapist } from '../../../redux/actions/Master.action';
import { FaEdit } from 'react-icons/fa';
import { PiWarningCircleBold } from 'react-icons/pi';

const Treatments = ({ patientIds }) => {

    const dispatch = useDispatch()
    const treatmentData = useSelector((state) => state.doctor)
    const doctorData = useSelector((state) => state.files)
    const masterData = useSelector((state) => state.master)
    const type = localStorage.getItem('type')
    const [show, setShow] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [treatmentId, setTreatmentId] = useState();

    const toggle = () => { setShow(!show) }
    const deleteToggle = () => { setDeleteModal(!deleteModal) }
    const updateToggle = () => { setUpdateModal(!updateModal) }

    const [doctorData1, setDoctorData1] = useState(false);
    const [counselorData1, setCounselorData1] = useState(false);
    const [skintherapistData1, setSkintherapistData1] = useState(false);
    const [lasertherapistData1, setLasertherapistData1] = useState(false);
    const [LHRtherapistData1, setLHRtherapistData1] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        search: '',
    });
    const [searchType, setSearchType] = useState('doctor');

    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(4);
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    }

    const searchData = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || ''
        };

        setSearchDefault(newSearchParams);

        if (searchType === 'doctor') {
            dispatch(allDoctorSearchDetail(newSearchQuery));
        } else if (searchType === 'counselor') {
            dispatch(searchAllCounselorDetail(newSearchParams));
        } else if (
            searchType === 'skintherapist' ||
            searchType === 'lasertherapist' ||
            searchType === 'LHRtherapist'
        ) {
            dispatch(searchTherapist(newSearchParams));
        }
    };

    const initialValues = {
        branch: '',
        doctor: '',
        counselor: '',
    }

    const [formData, setFormData] = useState({
        branch: '',
        doctor: '',
        counselor: '',
        skintherapist: '',
        lasertherapist: '',
        LHRtherapist: '',
        procedure: '',
        bodypart: '',
        skintype: '',
        machine: '',
        noOfsession: '',
        hairDensity: '',
        power: '',
        shortCount: '',
        remark: '',
    })

    const validationSchema = Yup.object().shape({
        branch: Yup.string().required('branch is required'),
        doctor: Yup.string().required('doctor is required'),
        counselor: Yup.string().required('counselor is required'),
    });

    const handleSuggestion = (values, { resetForm }) => {
        const payload = {
            patientId: patientIds,
            branch: values.branch,
            doctor: values.doctor,
            counselor: values.counselor,
            skintherapist: values.skintherapist,
            lasertherapist: values.lasertherapist,
            LHRtherapist: values.LHRtherapist,
            procedure: values.procedure,
            bodypart: values.bodypart,
            skintype: values.skintype,
            machine: values.machine,
            noOfsession: values.noOfsession,
            hairDensity: values.hairDensity,
            power: values.power,
            shortCount: values.shortCount,
            remark: values.remark,
        }
        dispatch(addTreatment(payload, limits, patientIds)).then(() => {
            toggle();
            resetForm();
        });
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        treatmentData?.getTreatment?.data?.totalCount / postPerPage,
    );

    const handleUpdate = (values) => {
        const payload = {
            patientId: patientIds,
            branch: values.branch,
            doctor: values.doctor,
            counselor: values.counselor,
            skintherapist: values.skintherapist,
            lasertherapist: values.lasertherapist,
            LHRtherapist: values.LHRtherapist,
            procedure: values.procedure,
            bodypart: values.bodypart,
            skintype: values.skintype,
            machine: values.machine,
            noOfsession: values.noOfsession,
            hairDensity: values.hairDensity,
            power: values.power,
            shortCount: values.shortCount,
            remark: values.remark,
        }
        dispatch(updateTreatment(payload, treatmentId, patientIds, limits)).then(() => {
            updateToggle()
        })
    }

    const handleDelete = () => {
        dispatch(deleteTreatment(limits, patientIds, treatmentId)).then(() => {
            deleteToggle()
            setMainPage(1);
        })
    }

    useEffect(() => {
        dispatch(allBranchDetail())
        dispatch(allCounselorDetail())
        dispatch(getTherapist())
        if (patientIds) {
            dispatch(getTreatment(limits, patientIds))
        }
    }, [mainPage, rowsPerPage, patientIds])

    return (
        <div>
            <div className="row">
                <div className='col-12'>
                    <div className="!bg-[#fff] shadow p-4 rounded-4 mt-3">
                        <div className="d-flex justify-between">
                            <div className="flex gap-3">
                                <RiStethoscopeFill className="fs-5" />
                                <h6>Treatments</h6>
                            </div>

                            <div className="flex">
                                <div className="flex items-center gap-3 text-sm">
                                    <div>
                                        Rows per page:
                                        <select
                                            value={rowsPerPage}
                                            onChange={handleRowsPerPageChange}
                                            className="ms-2 border rounded-md focus:outline-none"
                                        >
                                            <option value="">Select</option>
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={30}>30</option>
                                            <option value={50}>50</option>
                                        </select>
                                    </div>

                                    <div>
                                        {/* <SearchBar me="10px" borderRadius="30px" /> */}
                                    </div>
                                </div>
                                <div>
                                    <Button disabled={type === 'Receptionist'} className={`!bg-theme-dark !border-none d-flex gap-1 ${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={toggle}>
                                        {' '}
                                        Add New <MdAdd className="fs-4  fw-bold" />
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <TableContainer>
                                <Table className="table-bordered">
                                    <Thead className="!bg-theme-dark text-center">
                                        <Tr>
                                            <Th className="!text-white">Date</Th>
                                            <Th className="!text-white">Branch</Th>
                                            <Th className="!text-white">Doctor</Th>
                                            <Th className="!text-white">Counselor</Th>
                                            <Th className="!text-white">Skin Therapist</Th>
                                            <Th className="!text-white">Laser Therapist</Th>
                                            <Th className="!text-white">LHR Therapist</Th>
                                            <Th className="!text-white">Procedure</Th>
                                            <Th className="!text-white">Body Part</Th>
                                            <Th className="!text-white">Skin Type</Th>
                                            <Th className="!text-white">Machine</Th>
                                            <Th className="!text-white">No. of Session</Th>
                                            <Th className="!text-white">Hair Density</Th>
                                            <Th className="!text-white">Power</Th>
                                            <Th className="!text-white">Short Count</Th>
                                            <Th className="!text-white">Remark</Th>
                                            <Th className="!text-white">User</Th>
                                            <Th className="!text-white">Action</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody className="">
                                        {
                                            treatmentData?.getTreatment?.data?.treatmentInfo?.length > 0 ? (
                                                treatmentData?.getTreatment?.data?.treatmentInfo?.map((res) => {
                                                    return (
                                                        <Tr key={res._id}>
                                                            <Td>{new Date(res.createdAt).toLocaleDateString()}</Td>
                                                            <Td>{res.branch}</Td>
                                                            <Td>{res.doctor}</Td>
                                                            <Td>{res.counselor}</Td>
                                                            <Td>{res.skintherapist}</Td>
                                                            <Td>{res.lasertherapist}</Td>
                                                            <Td>{res.LHRtherapist}</Td>
                                                            <Td>{res.procedure}</Td>
                                                            <Td>{res.bodypart}</Td>
                                                            <Td>{res.skintype}</Td>
                                                            <Td>{res.machine}</Td>
                                                            <Td>{res.noOfsession}</Td>
                                                            <Td>{res.hairDensity}</Td>
                                                            <Td>{res.power}</Td>
                                                            <Td>{res.shortCount}</Td>
                                                            <Td>{res.remark}</Td>
                                                            <Td>{res?.authdata?.name}</Td>
                                                            <Td>
                                                                <div className='flex items-center gap-3'>
                                                                    <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><FaEdit className='text-success' title='update' onClick={() => { updateToggle(); setTreatmentId(res?._id); setFormData(res) }} /></button>
                                                                    <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><MdDelete className="text-danger" title="delete" onClick={() => { deleteToggle(); setTreatmentId(res?._id); }} /></button>
                                                                </div>
                                                            </Td>
                                                        </Tr>
                                                    )
                                                })
                                            ) : (
                                                <Tr>
                                                    <Td colSpan={15} textAlign={'center'}> No Any treatment</Td>
                                                </Tr>
                                            )
                                        }
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </div>
                        <div className="flex justify-end items-center mt-2">
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel=" >"
                                onPageChange={ChangeMainPage}
                                pageRangeDisplayed={5}
                                pageCount={PageCount}
                                previousLabel="< "
                                renderOnZeroPageCount={null}
                                className="pagination"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* add */}
            <Modal show={show} onHide={toggle} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Add Treatment</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSuggestion}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Branch</Form.Label>
                                            <Form.Select
                                                placeholder="Select Branch"
                                                name='branch'
                                                className="shadow-none focus:!border-theme-dark"
                                                onChange={(e) =>
                                                    setFieldValue('branch', e.target.value)}
                                                value={values.branch}
                                            >
                                                <option value='' selected>Select Branch</option>
                                                {
                                                    doctorData?.allBranch?.data?.Branches?.map((res) => {
                                                        return (
                                                            <>

                                                                <option value={res?.branchName} key={res._id}>{res.branchName}</option>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                            <ErrorMessage
                                                name="branch"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group controlId="campaignDetail">
                                            <Form.Label>Doctor Name</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="doctor"
                                                    placeholder={values.doctor || 'Select Doctor'}
                                                    value={values.doctor}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setDoctorData1(!doctorData1);
                                                        setSearchType('doctor');
                                                    }}
                                                />

                                                <div
                                                    className={`${doctorData1
                                                        ? 'opacity-100 visible'
                                                        : 'opacity-0 invisible'
                                                        } absolute w-full border top-full h-[180px] z-10 overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search Doctors`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {doctorData?.allDoctor?.data?.doctor?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('doctor', res.name);
                                                                setDoctorData1(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                                dispatch(allDoctorSearchDetail({ search: '' }));
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.name}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="doctor" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group controlId="campaignDetail">
                                            <Form.Label>Counselor Name</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="counselor"
                                                    placeholder={values.counselor || 'Select Counselor'}
                                                    value={values.counselor}
                                                    readOnly
                                                    className="border w-full outline-none  border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setCounselorData1(!counselorData1);
                                                        setSearchType('counselor');
                                                    }}
                                                />

                                                <div
                                                    className={`${counselorData1
                                                        ? 'opacity-100 visible'
                                                        : 'opacity-0 invisible'
                                                        } absolute w-full border z-10  top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search Counselors`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {doctorData?.allCounselor?.data?.CounselorsData?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('counselor', res.name);
                                                                setCounselorData1(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                                dispatch(searchAllCounselorDetail({ search: '' }));
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.name}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="counselor" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group controlId="skintherapist" className="mb-3">
                                            <Form.Label>Skintherapist</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="skintherapist"
                                                    placeholder={values.skintherapist || 'Select Skintherapist'}
                                                    value={values.skintherapist}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setSkintherapistData1(!skintherapistData1);
                                                        setSearchType('skintherapist');
                                                    }}
                                                />
                                                <div
                                                    className={`${skintherapistData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} 
                                                    absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search Skintherapist`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {masterData?.getTherapist?.data?.existingTherapist?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('skintherapist', res.name);
                                                                setSkintherapistData1(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                                dispatch(searchTherapist({ search: '' }));
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.name}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="skintherapist" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>

                                    <div className="col-4">
                                        <Form.Group controlId="lasertherapist" className="mb-3">
                                            <Form.Label>Lasertherapist</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="lasertherapist"
                                                    placeholder={values.lasertherapist || 'Select Lasertherapist'}
                                                    value={values.lasertherapist}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setLasertherapistData1(!lasertherapistData1);
                                                        setSearchType('lasertherapist');
                                                    }}
                                                />
                                                <div
                                                    className={`${lasertherapistData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} 
                                                    absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search Lasertherapist`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {masterData?.getTherapist?.data?.existingTherapist?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('lasertherapist', res.name);
                                                                setLasertherapistData1(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                                dispatch(searchTherapist({ search: '' }));
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.name}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="lasertherapist" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>

                                    <div className="col-4">
                                        <Form.Group controlId="LHRtherapist" className="mb-3">
                                            <Form.Label>LHRtherapist</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="LHRtherapist"
                                                    placeholder={values.LHRtherapist || 'Select LHRtherapist'}
                                                    value={values.LHRtherapist}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setLHRtherapistData1(!LHRtherapistData1);
                                                        setSearchType('LHRtherapist');
                                                    }}
                                                />
                                                <div
                                                    className={`${LHRtherapistData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} 
                                                    absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search LHRtherapist`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {masterData?.getTherapist?.data?.existingTherapist?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('LHRtherapist', res.name);
                                                                setLHRtherapistData1(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                                dispatch(searchTherapist({ search: '' }));
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.name}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="LHRtherapist" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>

                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Procedure</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="procedure"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('procedure', e.target.value)}
                                                value={values.procedure}
                                                placeholder="Enter procedure"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="procedure"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bodypart</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="bodypart"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('bodypart', e.target.value)}
                                                value={values.bodypart}
                                                placeholder="Enter bodypart"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="bodypart"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Skintype</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="skintype"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('skintype', e.target.value)}
                                                value={values.skintype}
                                                placeholder="Enter skintype"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="skintype"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Machine</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="machine"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('machine', e.target.value)}
                                                value={values.machine}
                                                placeholder="Enter machine"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="machine"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>No Of session</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="noOfsession"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('noOfsession', e.target.value)}
                                                value={values.noOfsession}
                                                placeholder="Enter noOfsession"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="noOfsession"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Hair Density</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="hairDensity"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('hairDensity', e.target.value)}
                                                value={values.hairDensity}
                                                placeholder="Enter hairDensity"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="hairDensity"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Power</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="power"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('power', e.target.value)}
                                                value={values.power}
                                                placeholder="Enter power"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="power"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Short Count</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="shortCount"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('shortCount', e.target.value)}
                                                value={values.shortCount}
                                                placeholder="Enter shortCount"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="shortCount"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Remark</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="remark"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('remark', e.target.value)}
                                                value={values.remark}
                                                placeholder="Enter remark"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="remark"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* Update */}
            <Modal show={updateModal} onHide={updateToggle} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Update Treatment</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpdate}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Branch</Form.Label>
                                            <Form.Select
                                                placeholder="Select Branch"
                                                name='branch'
                                                className="shadow-none focus:!border-theme-dark"
                                                onChange={(e) =>
                                                    setFieldValue('branch', e.target.value)}
                                                value={values.branch}
                                            >
                                                <option value='' selected>Select Branch</option>
                                                {
                                                    doctorData?.allBranch?.data?.Branches?.map((res) => {
                                                        return (
                                                            <>

                                                                <option value={res?.branchName} key={res._id}>{res.branchName}</option>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                            <ErrorMessage
                                                name="branch"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group controlId="campaignDetail">
                                            <Form.Label>Doctor Name</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="doctor"
                                                    placeholder={values.doctor || 'Select Doctor'}
                                                    value={values.doctor}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setDoctorData1(!doctorData1);
                                                        setSearchType('doctor');
                                                    }}
                                                />

                                                <div
                                                    className={`${doctorData1
                                                        ? 'opacity-100 visible'
                                                        : 'opacity-0 invisible'
                                                        } absolute w-full border z-10 top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search Doctors`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {doctorData?.allDoctor?.data?.doctor?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('doctor', res.name);
                                                                setDoctorData1(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                                dispatch(allDoctorSearchDetail({ search: '' }));
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.name}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="doctor" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group controlId="campaignDetail">
                                            <Form.Label>Counselor Name</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="counselor"
                                                    placeholder={values.counselor || 'Select Counselor'}
                                                    value={values.counselor}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setCounselorData1(!counselorData1);
                                                        setSearchType('counselor');
                                                    }}
                                                />

                                                <div
                                                    className={`${counselorData1
                                                        ? 'opacity-100 visible'
                                                        : 'opacity-0 invisible'
                                                        } absolute w-full border z-10 top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search Counselors`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {doctorData?.allCounselor?.data?.CounselorsData?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('counselor', res.name);
                                                                setCounselorData1(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                                dispatch(searchAllCounselorDetail({ search: '' }));
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.name}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="counselor" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group controlId="skintherapist" className="mb-3">
                                            <Form.Label>Skintherapist</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="skintherapist"
                                                    placeholder={values.skintherapist || 'Select Skintherapist'}
                                                    value={values.skintherapist}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setSkintherapistData1(!skintherapistData1);
                                                        setSearchType('skintherapist');
                                                    }}
                                                />
                                                <div
                                                    className={`${skintherapistData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} 
                                                    absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search Skintherapist`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {masterData?.getTherapist?.data?.existingTherapist?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('skintherapist', res.name);
                                                                setSkintherapistData1(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                                dispatch(searchTherapist({ search: '' }));
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.name}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="skintherapist" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group controlId="lasertherapist" className="mb-3">
                                            <Form.Label>Lasertherapist</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="lasertherapist"
                                                    placeholder={values.lasertherapist || 'Select Lasertherapist'}
                                                    value={values.lasertherapist}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setLasertherapistData1(!lasertherapistData1);
                                                        setSearchType('lasertherapist');
                                                    }}
                                                />
                                                <div
                                                    className={`${lasertherapistData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} 
                                                    absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search Lasertherapist`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {masterData?.getTherapist?.data?.existingTherapist?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('lasertherapist', res.name);
                                                                setLasertherapistData1(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                                dispatch(searchTherapist({ search: '' }));
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.name}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="lasertherapist" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group controlId="LHRtherapist" className="mb-3">
                                            <Form.Label>LHRtherapist</Form.Label>
                                            <div className="relative">
                                                <input
                                                    name="LHRtherapist"
                                                    placeholder={values.LHRtherapist || 'Select LHRtherapist'}
                                                    value={values.LHRtherapist}
                                                    readOnly
                                                    className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                    onClick={() => {
                                                        setLHRtherapistData1(!LHRtherapistData1);
                                                        setSearchType('LHRtherapist');
                                                    }}
                                                />
                                                <div
                                                    className={`${LHRtherapistData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} 
                                                    absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        value={searchQuery}
                                                        placeholder={`Search LHRtherapist`}
                                                        onChange={searchData}
                                                        className="w-full border p-2 rounded outline-none"
                                                    />
                                                    {masterData?.getTherapist?.data?.existingTherapist?.map((res) => (
                                                        <p
                                                            key={res._id}
                                                            onClick={() => {
                                                                setFieldValue('LHRtherapist', res.name);
                                                                setLHRtherapistData1(false);
                                                                setSearchQuery('');
                                                                setSearchDefault({ page: '', search: '' });
                                                                dispatch(searchTherapist({ search: '' }));
                                                            }}
                                                            className="text-gray-700 py-1 cursor-pointer"
                                                        >
                                                            {res.name}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <ErrorMessage name="LHRtherapist" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Procedure</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="procedure"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('procedure', e.target.value)}
                                                value={values.procedure}
                                                placeholder="Enter procedure"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="procedure"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bodypart</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="bodypart"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('bodypart', e.target.value)}
                                                value={values.bodypart}
                                                placeholder="Enter bodypart"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="bodypart"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Skintype</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="skintype"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('skintype', e.target.value)}
                                                value={values.skintype}
                                                placeholder="Enter skintype"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="skintype"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Machine</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="machine"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('machine', e.target.value)}
                                                value={values.machine}
                                                placeholder="Enter machine"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="machine"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>No Of session</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="noOfsession"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('noOfsession', e.target.value)}
                                                value={values.noOfsession}
                                                placeholder="Enter noOfsession"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="noOfsession"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Hair Density</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="hairDensity"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('hairDensity', e.target.value)}
                                                value={values.hairDensity}
                                                placeholder="Enter hairDensity"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="hairDensity"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Power</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="power"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('power', e.target.value)}
                                                value={values.power}
                                                placeholder="Enter power"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="power"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Short Count</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="shortCount"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('shortCount', e.target.value)}
                                                value={values.shortCount}
                                                placeholder="Enter shortCount"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="shortCount"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Remark</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="remark"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('remark', e.target.value)}
                                                value={values.remark}
                                                placeholder="Enter remark"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="remark"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete */}
            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDelete}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default Treatments
